export enum CarStatus {
  IsNew,
  IsUsed
}
